import React, { useState } from "react";

import { FormattedMessage, useIntl } from "react-intl";

import { CwsA } from "cms-web-styleguide/dist/components/CwsA/CwsA";
import { CwsButton } from "cms-web-styleguide/dist/components/CwsButton/CwsButton";
import { CwsCheckbox } from "cms-web-styleguide/dist/components/CwsForm/CwsCheckbox/CwsCheckbox";
import { CwsDivider } from "cms-web-styleguide/dist/components/CwsDivider/CwsDivider";
import { CwsModalFooter } from "cms-web-styleguide/dist/components/CwsModal/CwsModalFooter/CwsModalFooter";
import { CwsP } from "cms-web-styleguide/dist/components/CwsTypography/CwsP/CwsP";

import { getCookies } from "../../utils/utils";

import styles from "./SelectionTab.module.scss";

const SelectionTab = (props) => {
  const { onSaveCookies } = props;

  const browserCookies = getCookies();

  const intl = useIntl();

  const [preferencesState, setPreferencesState] = useState(
    browserCookies["preferences"] ? browserCookies["preferences"] : false,
  );

  const [checkedState, setCheckedState] = useState(
    browserCookies["statistics_and_analytics"] ? browserCookies["statistics_and_analytics"] : false,
  );

  const [marketingState, setMarketingCheckedState] = useState(
    browserCookies["marketing_cookies"] ? browserCookies["marketing_cookies"] : false,
  );

  const cookies = {
    necessaryCookies: true,
    preferences: preferencesState,
    statisticsAnalyticsCookies: checkedState,
    marketingCookies: marketingState,
  };

  return (
    <>
      <CwsCheckbox checked={cookies.necessaryCookies} disabled iconMode="dom" id="necessary-cookies">
        <FormattedMessage id="popup.selection.checkbox.necessary.cookies.label" />
      </CwsCheckbox>

      <CwsP className="cws-mt-tiny cws-ml-s cws-pl-xs-sub" color="dark-grey" hideSpacing size="small">
        <FormattedMessage id="popup.selection.checkbox.necessary.cookies.description" />
      </CwsP>

      <CwsDivider className="cws-my-xs" />

      <CwsCheckbox
        checked={cookies.preferences}
        iconMode="dom"
        id="preferences-cookies"
        onChange={() => setPreferencesState(!preferencesState)}
        optional
      >
        <FormattedMessage id="popup.selection.checkbox.preferences.cookies.label" />
      </CwsCheckbox>

      <CwsP className="cws-mt-tiny cws-ml-s cws-pl-xs-sub" hideSpacing size="small">
        <FormattedMessage id="popup.selection.checkbox.preferences.cookies.description" />
      </CwsP>

      <CwsDivider className="cws-my-xs" />

      <CwsCheckbox
        checked={checkedState}
        iconMode="dom"
        id="statistics-analytics-cookies"
        onChange={() => setCheckedState(!checkedState)}
        optional
      >
        <FormattedMessage id="popup.selection.checkbox.statistics.analytics.cookies.label" />
      </CwsCheckbox>

      <CwsP className="cws-mt-tiny cws-ml-s cws-pl-xs-sub" hideSpacing size="small">
        <FormattedMessage id="popup.selection.checkbox.statistics.analytics.cookies.description" />
      </CwsP>

      <CwsDivider className="cws-my-xs" />

      <CwsCheckbox
        checked={marketingState}
        iconMode="dom"
        id="marketing-cookies"
        onChange={() => setMarketingCheckedState(!marketingState)}
        optional
      >
        <FormattedMessage id="popup.selection.checkbox.marketing.cookies.label" />
      </CwsCheckbox>

      <CwsP className="cws-mt-tiny cws-ml-s cws-pl-xs-sub" hideSpacing size="small">
        <FormattedMessage
          id="popup.selection.checkbox.marketing.cookies.description"
          values={{
            linkPrivacyPolicyGoogle: (
              <CwsA
                inline
                href={intl.formatMessage({
                  id: "privacy.policy.google.link",
                })}
                size="small"
                target="_blank"
              >
                {intl.formatMessage({
                  id: "privacy.policy.google.name",
                })}
              </CwsA>
            ),
            linkPrivacyPolicyLinkedIn: (
              <CwsA
                inline
                href={intl.formatMessage({
                  id: "privacy.policy.linkedin.link",
                })}
                size="small"
                target="_blank"
              >
                {intl.formatMessage({
                  id: "privacy.policy.linkedin.name",
                })}
              </CwsA>
            ),
            linkPrivacyPolicyMeta: (
              <CwsA
                inline
                href={intl.formatMessage({
                  id: "privacy.policy.meta.link",
                })}
                size="small"
                target="_blank"
              >
                {intl.formatMessage({
                  id: "privacy.policy.meta.name",
                })}
              </CwsA>
            ),
          }}
        />
      </CwsP>

      <CwsModalFooter className={styles["cwc-selection__buttons"]}>
        <CwsButton onClick={() => onSaveCookies()}>{<FormattedMessage id="popup.button.agree.to.all" />}</CwsButton>
        <CwsButton onClick={() => onSaveCookies(cookies)} variant="secondary">
          {<FormattedMessage id="popup.button.agree.to.selection" />}
        </CwsButton>
      </CwsModalFooter>
    </>
  );
};

export { SelectionTab };
